/**
 * Runtime Configuration
 * This file can be updated without rebuilding the application
 */

export interface RuntimeConfig {
  openaiApiKey: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  gaMeasurementId?: string;
}

// Default configuration (will be overridden by environment variables or runtime updates)
export const runtimeConfig: RuntimeConfig = {
  openaiApiKey: import.meta.env.VITE_OPENAI_API_KEY || "",
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || "",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "",
  gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || "",
};

// Function to update configuration at runtime
export function updateRuntimeConfig(newConfig: Partial<RuntimeConfig>) {
  Object.assign(runtimeConfig, newConfig);
  console.log("🔧 Runtime config updated:", Object.keys(newConfig));
}

// Function to get OpenAI API key with fallback
export function getOpenAIApiKey(): string {
  // Try environment variable first
  if (
    import.meta.env.VITE_OPENAI_API_KEY &&
    import.meta.env.VITE_OPENAI_API_KEY !== "dummy-key"
  ) {
    return import.meta.env.VITE_OPENAI_API_KEY;
  }

  // Try runtime config
  if (runtimeConfig.openaiApiKey) {
    return runtimeConfig.openaiApiKey;
  }

  // Try localStorage (for manual override)
  const storedKey = localStorage.getItem("openai_api_key");
  if (storedKey) {
    return storedKey;
  }

  return "";
}

// Function to check if OpenAI is available
export function isOpenAIAvailable(): boolean {
  const key = getOpenAIApiKey();
  return key.length > 0 && key !== "dummy-key";
}
